import { Rule } from '@core/models/attendance/rule';
import { BillingInvoice } from '@core/models/billing/billing-invoice';
import { User } from '@core/models/user/user';
import { Location } from '@core/models/location/location';
import { Employee } from '@core/models/employee/employee';
import { Paystub } from '@core/models/shared/paystub/paystub';
import { Document } from '@core/models/shared/document/document';
import { Deduction } from '@core/models/employee/deduction/deduction';
import { Benefit } from '@core/models/employee/benefit/benefit';
import { Payroll } from '@core/models/payroll/payroll';
import { PayrollPayment } from '@core/models/payroll/payroll-payment';
import { Contractor } from '@core/models/contractor/contractor';
import { Deposit } from '@core/models/shared/deposit/deposit';
import { EmployeeWage } from '@core/models/employee/employee-wage';
import { Workplace } from '@core/models/shared/workplace/workplace';
import { LeavePolicy } from '@core/models/leave/leave-policy';

export interface IEntitiesState {
    entities: {
        employee: { [id: string]: Employee };
        contractor: { [id: string]: Contractor };
        document: { [id: string]: Document };
        deposit: { [id: string]: Deposit };
        payroll: { [id: string]: Payroll };
        payrollPayment: { [id: string]: PayrollPayment };
        invoice: { [id: string]: BillingInvoice }
        location: { [id: string]: Location };
        locationRule: { [id: string]: Rule };

        // deliveryOrder: { [id: string]: DeliveryOrder };
        // deliveryOrderConfig: { [id: string]: DeliveryOrderConfig };
        employeePaystub: { [id: string]: Paystub };
        employeeDocument: { [id: string]: Document };
        employeeDeduction: { [id: string]: Deduction };
        employeeBenefit: { [id: string]: Benefit };
        employeeWage: { [id: string]: EmployeeWage };

        contractorPayment: { [id: string]: Paystub };
        contractorDocument: { [id: string]: Document };

        user: { [id: string]: User };
        workplace: { [id: string]: Workplace };
        leavePolicy: { [id: string]: LeavePolicy };
        // driver: { [id: string]: User };

        // reportDeliveriesByDriver: { [id: string]: any }
    };
    relationships: {
        employeePaystubs: { [id: string]: string[] };
        employeeDocuments: { [id: string]: string[] };
        employeeDeductions: { [id: string]: string[] };
        employeeBenefits: { [id: string]: string[] };
        employeeWages: { [id: string]: string[] };
        contractorPayments: { [id: string]: string[] };
        contractorDocuments: { [id: string]: string[] };
        // connectionDSTExclusions: { [id: string]: string[] };
        // connectionPermissions: { [id: string]: string[] };
    };
}

export function initialEntitiesState(): IEntitiesState {
    return {
        entities: {
            // board: {},
            
            // connection: {},
            // connectionPermission: {},
            employee: {},
            contractor: {},
            document: {},
            deposit: {},
            payroll: {},
            payrollPayment: {},
            invoice: {},
            location: {},
            locationRule: {},
            employeePaystub: {},
            employeeDocument: {},
            employeeDeduction: {},
            employeeBenefit: {},
            employeeWage: {},
            contractorPayment: {},
            contractorDocument: {},
            user: {},
            workplace: {},
            leavePolicy: {}
        },
        relationships: {
            employeePaystubs: {},
            employeeDocuments: {},
            employeeDeductions: {},
            employeeBenefits: {},
            employeeWages: {},
            contractorPayments: {},
            contractorDocuments: {},
        },
    };
}
